/* hej-wishlist-sync: houdt de bewaarde producten van dit apparaat en het klantaccount gelijk (2026-10-21, taak
 * .ai/tasks/active/2026-10-21-wishlist-pagina-met-inloggen.md). Geladen in layout/theme.liquid, in <head> met defer,
 * zodat het vóór de kaartscripts draait en die meteen de goede bladwijzers tonen.
 *
 * Op dit apparaat staat de lijst in localStorage onder hej_saved_products ({ v: 1, items: [{ productId }] }); drie
 * scripts schrijven daar al in (collectiekaart, gerelateerde accessoires, Bewaar voor later). Die blijven ongewijzigd:
 * dit script luistert in de capture-fase mee op hun knoppen en kijkt een tik later wat er veranderd is.
 *
 * Het account is de waarheid. Bij elke pagina neemt dit apparaat de accountlijst over (data-account). Naar het
 * account gaan alleen wijzigingen: plus (erbij) en min (eraf), en workers/hej-wishlist past die toe op wat er dan in
 * het account staat. Een apparaat met een verouderde of lege lijst kan zo nooit iets wissen dat het niet zelf heeft
 * weggeklikt. Tot 2026-10-21 (middag) ging de hele lijst mee en overschreef die het account; dat wiste een product dat
 * via de Admin API in het account was gezet, binnen twee minuten.
 *
 * Eerste keer ingelogd op dit apparaat voor deze klant: wat hier al bewaard was gaat als plus naar het account, zodat
 * niets kwijtraakt wat vóór het inloggen bewaard werd. Niet ingelogd, terwijl dit apparaat eerder bij een klant hoorde:
 * uitgelogd, dus de lijst van die klant gaat van het apparaat af (gedeelde computer). Wie nooit inlogde houdt zijn
 * lijst gewoon.
 */
(function () {
  var script = document.currentScript;
  if (!script) return;
  var LIJST = 'hej_saved_products';
  var KLANT = 'hej_wl_klant';
  /* Een paar snelle klikken worden één verzending. */
  var BUNDEL_MS = 400;

  var endpoint = script.getAttribute('data-endpoint');
  var klant = script.getAttribute('data-klant') || '';
  var tijd = script.getAttribute('data-tijd') || '';
  var handtekening = script.getAttribute('data-handtekening') || '';
  var account = (script.getAttribute('data-account') || '').split(',').filter(Boolean);

  function lees(sleutel) {
    try { return window.localStorage.getItem(sleutel); } catch (e) { return null; }
  }
  function schrijf(sleutel, waarde) {
    try {
      if (waarde === null) window.localStorage.removeItem(sleutel);
      else window.localStorage.setItem(sleutel, waarde);
    } catch (e) {}
  }
  function lokaal() {
    try {
      var data = JSON.parse(lees(LIJST) || 'null');
      if (!data || !Array.isArray(data.items)) return [];
      return data.items.map(function (item) { return String(item.productId); }).filter(Boolean);
    } catch (e) { return []; }
  }
  function zetLokaal(ids) {
    schrijf(LIJST, JSON.stringify({ v: 1, items: ids.map(function (id) { return { productId: id }; }) }));
  }
  function zonder(a, b) {
    return a.filter(function (id) { return b.indexOf(id) === -1; });
  }

  /* Tellertje bij Wishlist in het winkelwagenmenu (2026-10-22, gebruiker; markup in sections/header.liquid). Leest de
     lijst op dit apparaat: zonder inlog is dat de hele lijst, met inlog is hij hieronder eerst gelijkgezet aan het
     account. Telt mee bij bewaren en weghalen (de bewaarscripts schrijven eerst, dus een tik later lezen) en bij een
     wijziging in een ander tabblad. */
  function teller() {
    var aantal = lokaal().length;
    Array.prototype.forEach.call(document.querySelectorAll('[data-hej-wl-teller]'), function (el) {
      el.textContent = aantal ? String(aantal) : '';
      el.classList.toggle('is-empty', !aantal);
    });
    Array.prototype.forEach.call(document.querySelectorAll('.lvh-cd-wl-icoon'), function (el) {
      el.classList.toggle('is-gevuld', aantal > 0);
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-wish-product], [data-hap-save-btn]')) setTimeout(teller, 0);
  }, true);
  window.addEventListener('storage', function (e) { if (e.key === LIJST) teller(); });

  /* Oude sleutel uit de eerste versie; niet meer gebruikt. */
  schrijf('hej_wl_wacht', null);

  if (!klant) {
    if (lees(KLANT)) { zetLokaal([]); schrijf(KLANT, null); }
    teller();
    return;
  }
  if (!endpoint || !handtekening) { teller(); return; }

  function verstuur(plus, min, samengevoegd) {
    if (!plus.length && !min.length) return;
    var body = JSON.stringify({ klant: klant, tijd: tijd, handtekening: handtekening, plus: plus, min: min });
    /* text/plain houdt het een eenvoudig verzoek zonder voorafgaande CORS-controle; keepalive laat het afmaken
       als de bezoeker meteen doorklikt. */
    fetch(endpoint, { method: 'POST', body: body, keepalive: true, headers: { 'content-type': 'text/plain' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.ok && samengevoegd) document.dispatchEvent(new CustomEvent('hej:wishlist-samengevoegd', { detail: { ids: d.ids || [] } }));
      })
      .catch(function () {});
  }

  var hier = lokaal();
  if (lees(KLANT) !== klant) {
    var erbij = zonder(hier, account);
    zetLokaal(account.concat(erbij));
    schrijf(KLANT, klant);
    verstuur(erbij, [], true);
  } else if (hier.join(',') !== account.join(',')) {
    zetLokaal(account);
  }

  teller();
  var laatst = lokaal();
  var plusWacht = [];
  var minWacht = [];
  var timer = 0;
  function verzendNu() {
    clearTimeout(timer);
    timer = 0;
    var plus = plusWacht, min = minWacht;
    plusWacht = [];
    minWacht = [];
    verstuur(plus, min, false);
  }
  function controleer() {
    var nu = lokaal();
    var erbij = zonder(nu, laatst);
    var eraf = zonder(laatst, nu);
    laatst = nu;
    if (!erbij.length && !eraf.length) return;
    plusWacht = zonder(plusWacht, eraf).concat(erbij);
    minWacht = zonder(minWacht, erbij).concat(eraf);
    clearTimeout(timer);
    timer = setTimeout(verzendNu, BUNDEL_MS);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-wish-product], [data-hap-save-btn]')) setTimeout(controleer, 0);
  }, true);
  /* Wie binnen BUNDEL_MS wegklikt, verstuurt alsnog. */
  window.addEventListener('pagehide', function () { if (timer) verzendNu(); });
})();
